import { create } from "zustand";
import {
  CertificationForm,
  CertificationPayload,
} from "../types/certification";

type CertificationState = {
  loading: boolean;
  updateCertifications: (data: CertificationForm[]) => Promise<boolean>;
};

const getAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch (e) {
    console.error("❌ Failed to parse auth token:", e);
    return null;
  }
};

export const useCertificationStore = create<CertificationState>((set) => ({
  loading: false,

  updateCertifications: async (data) => {
    try {
      set({ loading: true });

      const token = getAccessToken();
      if (!token) throw new Error("No access token found");

      const payload: { certifications: CertificationPayload[] } = {
        certifications: data.map((c) => ({
          title: c.title,
          issuer: c.organization,
          issue_date: `${c.issueDate}-31`,
          expire_date: c.current ? null : `${c.expDate}-31`,
          is_lifetime: c.current,
          image: "",
        })),
      };

      const res = await fetch(
        "https://admin-talentlink.digiline.id/api/candidate/certifications",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Update certification failed");

      return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
